/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFourByFour32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M12.069 18.532v-1.58h-1.452V11.5H8.368L4 17.068v1.464h4.614V20.5h2.003v-1.968h1.452zm-3.396-4.157v2.577H5.909c.222-.207.386-.402.68-.777l1.463-1.904c.34-.427.504-.686.62-.958h.036c-.035.285-.035.505-.035 1.062zM12.21 20.5h2.155l1.16-1.528c.163-.233.304-.466.374-.635h.024c.058.182.187.415.351.635l1.16 1.528h2.353L17.2 17.12l2.39-3.095h-2.214l-1.007 1.386c-.14.207-.27.427-.34.634h-.023a2.4 2.4 0 00-.34-.634l-1.007-1.386h-2.319l2.413 3.134L12.21 20.5zM28 18.532v-1.58h-1.452V11.5h-2.249l-4.368 5.568v1.464h4.614V20.5h2.003v-1.968H28zm-3.396-4.157v2.577H21.84c.223-.207.387-.402.68-.777l1.463-1.904c.34-.427.504-.686.62-.958h.036c-.035.285-.035.505-.035 1.062z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M.25 7A4.75 4.75 0 015 2.25h22A4.75 4.75 0 0131.75 7v18A4.75 4.75 0 0127 29.75H5A4.75 4.75 0 01.25 25V7zM5 3.75A3.25 3.25 0 001.75 7v18A3.25 3.25 0 005 28.25h22A3.25 3.25 0 0030.25 25V7A3.25 3.25 0 0027 3.75H5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.25 24v-1.333h1.5V24A2.75 2.75 0 0126 26.75h-2.444v-1.5H26c.69 0 1.25-.56 1.25-1.25zM18 25.25h3.333v1.5H18v-1.5zM4.75 8v2h-1.5V8A2.75 2.75 0 016 5.25h3v1.5H6c-.69 0-1.25.56-1.25 1.25z'
      />
    </svg>
  );
}

export default SvgFourByFour32;
